export async function requireImageAsync(fileName: string): Promise<string> {
  try {
    return (await require(`./../${fileName}`) as string);
  } catch (error) {
    console.error(`${fileName} not found`);
    return '';
  }
}

/* eslint-disable @typescript-eslint/no-var-requires */
export function requireImage(fileName: string): string {
  try {
    return require(`./../${fileName}`) as string;
  } catch {
    console.error(`${fileName} not found`);
    return '';
  }
}
/* eslint-enable @typescript-eslint/no-var-requires */
